// import { set } from "lodash";
import BaseCommand from "./baseCommand";
import { updateSection } from "../actions/DocumentActions";

class ReOrderComponentInCoverPageCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const {
      mode,
      layout,
      newRow,
      rowIndex,
      colIndex,
      draggedSection,
      component,
      components,
      draggedRowIndex,
      draggedColumnIndex,
      updateDraggedSection,
      draggedFrom,
      draggedTo,
      updateLayoutInsideComponent,
    } = this.componentData;

    if (draggedFrom === draggedTo) {
      let coverpageComponent = JSON.parse(JSON.stringify(component));
      this.newLayout = JSON.parse(JSON.stringify(layout));
      // add the element
      if (newRow) {
        this.newLayout.splice(rowIndex, 0, [draggedSection.id]);
      } else if (!newRow) {
        const rowIDs = JSON.parse(JSON.stringify(this.newLayout[rowIndex]));
        rowIDs.splice(colIndex, 0, draggedSection.id);
        this.newLayout[rowIndex] = rowIDs;
      }

      // remove old from layout
      let removeRowIndex = draggedRowIndex;
      let removeColIndex = draggedColumnIndex;
      if (newRow && rowIndex <= draggedRowIndex) {
        removeRowIndex += 1;
      } else if (
        draggedRowIndex === rowIndex &&
        colIndex < draggedColumnIndex
      ) {
        removeColIndex += 1;
      }
      if (this.newLayout[removeRowIndex].length === 1) {
        this.isOldRowDelted = true;
        this.newLayout.splice(removeRowIndex, 1);
      } else {
        this.newLayout[removeRowIndex].splice(removeColIndex, 1);
      }

      updateLayoutInsideComponent(
        coverpageComponent.content.id,
        this.newLayout,
        draggedTo,
      );

      coverpageComponent = {
        ...coverpageComponent.content,
        data: {
          ...coverpageComponent.content.data,
          components,
          layout: this.newLayout,
        },
      };

      updateSection(mode)(coverpageComponent);
    } else {
      // handle draggeed form outside coverpage
      console.error(
        "Cannot move component from ",
        this.componentData.draggedFrom,
        "to",
        this.componentData.draggedTo,
      );
    }
    updateDraggedSection(null, null, null, null);
  }

  undo() {
    const {
      mode,
      layout,
      component,
      updateLayoutInsideComponent,
      draggedTo,
    } = this.componentData;

    updateLayoutInsideComponent(component.content.id, layout, draggedTo);
    updateSection(mode)(component.content);
  }
}

export default ReOrderComponentInCoverPageCommand;



// WEBPACK FOOTER //
// ./src/commands/reOrderComponentInCoverPageCommand.js